import { NgModule, AfterContentInit, Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';

declare let $: any;

@Directive({
    selector: '[close-on-click]',
    standalone: false
})
export class TopNavCloseOnClickDirective implements AfterContentInit, OnDestroy {
    listenClick: Function;

    constructor(protected el: ElementRef,
                protected renderer: Renderer2) {
    }

    ngAfterContentInit(): void {
        setTimeout(() => {
            this.listenClick = this.renderer.listen(this.el.nativeElement, 'click', this.onClick);
        });
    }

    ngOnDestroy() {
        if(this.listenClick instanceof Function) {
            this.listenClick();
        }
    }

    onClick({target}) {
        let lvl1 = $(target).closest('.level-1');
        if(lvl1.length === 1) {
            let lvl2 = lvl1.find('.level-2.show');
            if(lvl2.length === 1) {
                lvl2.removeClass('show');
            }
        }
    }

}

@NgModule({
    declarations: [TopNavCloseOnClickDirective],
    exports: [TopNavCloseOnClickDirective]
})
export class TopNavCloseOnClickDirectiveModule {}

@Directive({
    selector: '[collapse-on-click]',
    standalone: false
})
export class TopNavCollapseOnClickDirective extends TopNavCloseOnClickDirective {

    constructor(protected el: ElementRef,
                protected renderer: Renderer2) {
        super(el, renderer);
    }

    onClick({target}) {
        let lvl1 = $(target).closest('.level-1');
        if(lvl1.length === 1) {
            lvl1.children('li.nav-item.has-children')
                .toggleClass('collapsed');
        }
    }

}

@NgModule({
    declarations: [TopNavCollapseOnClickDirective],
    exports: [TopNavCollapseOnClickDirective]
})
export class TopNavCollapseOnClickDirectiveModule {}
